module.exports = __webpack_public_path__ + "static/media/Path.10a723f2.png";